<template>
  <v-container class="mt-4 pa-0">
    <v-card
      color="primary"
      class="elevation-1 mx-auto"
      :style="{ height: '85vh' }"
    >
      <v-toolbar color="primary" flat>
        <v-tooltip bottom>
          <v-toolbar-side-icon slot="activator" @click="reset()" icon>
            <v-icon>arrow_back</v-icon>
          </v-toolbar-side-icon>
          <span>Return to List</span>
        </v-tooltip>
        <h2>
          <a
            target="new"
            :href="`https://ops.bohmtech.com/web#id=${currentLocation[0]}&view_type=form&model=stock.location`"
            :style="{ color: '#F04E23', textDecoration: 'none' }"
            class="ml-2"
            >{{ currentLocation[1] }}</a
          >
        </h2>
        <v-spacer></v-spacer>
      </v-toolbar>
      <div
        :style="{ height: '90%', overflow: 'scroll' }"
        v-if="!!quants.length"
      >
        <v-stepper
          v-for="(item, hIndex) in quantsModel"
          v-model="currentStep"
          vertical
          class="elevation-0"
          :key="`${hIndex + 1}`"
        >
          <v-stepper-step :step="hIndex + 1" :key="`${hIndex + 1}-head`">{{
            item.name
          }}</v-stepper-step>
          <v-stepper-content :key="`${hIndex + 1}-content`" :step="hIndex + 1">
            <v-card color="primary elevation-0">
              <v-form
                @submit.prevent="
                  currentStep < quantsModel.length
                    ? currentStep++
                    : submitResults()
                "
              >
                <v-text-field
                  v-if="!serialOnly && storedType != 5"
                  box
                  color="secondary"
                  v-model="quantsModel[hIndex]['givenQty']"
                  :name="`${currentLocation[0]}-${item.defaultCode}`"
                  :label="`How many ${item.defaultCode}'s are in this location?`"
                  :id="`${currentLocation[0]}-${item.defaultCode}`"
                  @keyup="$forceUpdate()"
                  type="tel"
                  mask="######"
                />

                <v-combobox
                  v-else-if="serialOnly && storedType != 5"
                  autofocus
                  @change="$forceUpdate()"
                  chips
                  :color="
                    item.serials.length !=
                    quantsModel[hIndex]['enteredSerials'].length
                      ? 'error'
                      : 'success'
                  "
                  deletable-chips
                  :hint="
                    item.serials.length !=
                    quantsModel[hIndex]['enteredSerials'].length
                      ? `There should be ${item.serials.length} serial(s) for this product!`
                      : ''
                  "
                  label="Scan the Serials"
                  multiple
                  persistent-hint
                  v-model="quantsModel[hIndex]['enteredSerials']"
                />

                <v-text-field
                  v-else-if="storedType == 5"
                  box
                  color="secondary"
                  v-model="quantsModel[hIndex]['weight']"
                  :name="`${currentLocation[0]}-${item.defaultCode}`"
                  :label="`How much does ${item.defaultCode} weigh? (LBs)`"
                  :id="`${currentLocation[0]}-${item.defaultCode}`"
                  @keyup="$forceUpdate()"
                  type="tel"
                />

                <v-card-actions>
                  <v-btn
                    @click="currentStep > 1 ? currentStep-- : reset()"
                    >{{currentStep &gt; 1 ? 'Back' : 'Cancel'}}</v-btn
                  >
                  <v-btn
                    color="success"
                    type="submit"
                    :disabled="
                      !quantsModel[hIndex]['weight'] &&
                      !quantsModel[hIndex]['givenQty'] &&
                      !quantsModel[hIndex]['enteredSerials'].length
                    "
                    >{{currentStep &lt; quantsModel.length ? 'Next' : 'Submit'}}</v-btn
                  >
                </v-card-actions>
              </v-form>
            </v-card>
          </v-stepper-content>
        </v-stepper>
      </div>
      <div v-else :style="{ marginTop: '10vh' }">
        <v-card-text class="text-xs-center">
          <h2>No Products Found in this Location</h2>
          <v-btn @click="handleNoInventory()">Go Back to Location List</v-btn>
        </v-card-text>
      </div>
    </v-card>

    <SerialDialog
      v-model="serialDialog"
      :results="results"
      :currentLocation="currentLocation"
    />
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import SerialDialog from "@/components/inventory/SerialDialog";
import LoginCheck from "@/mixins/LoginCheck";

export default {
  name: "InventoryEval",

  data() {
    return {
      currentStep: 1,
      givenAnswers: [],
      results: [],
      serialDialog: false
    };
  },

  mixins: [LoginCheck],

  components: {
    SerialDialog
  },

  async beforeMount() {
    await this.getLocationInventory({ locationID: this.$route.params.id, type: this.$route.query.type });
    await this.getSelectedLocation({ locationID: this.$route.params.id });
    await this.getSettings("inventory");
  },

  watch: {
    quants: {
      async handler() {
        await this.getTracking();
      },
      deep: true
    }
  },

  computed: {
    ...mapGetters({
      quants: "inventory/getLocationInventory",
      user: "app/getUser",
      selectedLocation: "inventory/getSelectedLocation",
      products: "productTemplate/getProduct",
      storedType: "inventory/getSearchType",
      settings: "settings/getSettings",
      filters: "inventory/getFilters"
    }),

    uniqueSkus() {
      return [...new Set(this.quants.map(x => x.product_id[1]))];
    },

    quantsModel() {
      let data = [];
      this.uniqueSkus.forEach((sku, index) => {
        data[index] = {
          defaultCode: sku.split("]")[0].replace("[", ""),
          correctQty: 0,
          givenQty: "",
          tracking: "",
          serials: [],
          enteredSerials: []
        };
        this.quants.forEach(item => {
          if (sku === item.product_id[1]) {
            data[index].name = sku;
            data[index].correctQty += item.quantity;
            data[index].product_id = item.product_id;
            data[index].product_tmpl_id = item.product_tmpl_id;
            data[index].serials.push(item.lot_id[1]);

            this.products.forEach(product => {
              if (product.product_variant_ids.includes(item.product_id[0])) {
                data[index].tracking = product.tracking;
              }
            });
          }
        });
      });

      return data;
    },

    currentLocation() {
      if (this.selectedLocation[0]) {
        return [
          this.selectedLocation[0].id,
          this.selectedLocation[0].complete_name.substring(
            this.selectedLocation[0].complete_name.indexOf("/") + 1
          )
        ];
      } else return [false, false];
    },

    allSerials() {
      let serials = [];
      this.quantsModel.forEach(quant => {
        quant.serials.forEach(serial => {
          serials.push(serial);
        });
      });
      return serials;
    },

    serialOnly() {
      return this.storedType === 4;
    }
  },

  methods: {
    ...mapActions({
      getLocationInventory: "inventory/getLocationInventory",
      getSelectedLocation: "inventory/getSelectedLocation",
      createException: "inventory/createException",
      updateEvalDate: "inventory/updateEvalDate",
      loadLocations: "inventory/searchLocations",
      searchProduct: "productTemplate/search",
      getSettings: "settings/getSettings",
      updateWeight: "inventory/updateProductWeight"
    }),

    reset() {
      this.$router.push("/inventory");
    },

    totalCount(sku) {
      let count = 0;
      this.quants.map(item => {
        if (item[this.filterBy][1] == sku) count += item.quantity;
      });

      return count;
    },

    async submitResults() {
      try {
        if (!this.serialOnly && this.storedType != 5) {
          let incorrectSerial = false;
          this.quantsModel.forEach(async (item, index) => {
            this.results[index] = {
              location: this.currentLocation,
              product: item.product_id,
              evalBy: this.user.displayName,
              correctValue: item.correctQty,
              enteredValue: item.givenQty,
              correctSerials: item.serials,
              enteredSerials: [],
              tracking: item.tracking
            };
            if (item.correctQty != item.givenQty) {
              this.results[index].state = "waiting";
              if (item.tracking === "serial") {
                incorrectSerial = true;
              }
            } else {
              this.results[index].state = "correct";
            }
          });

          if (!incorrectSerial) {
            this.results.forEach(async result => {
              await this.createException(result);
            });
            await this.updateEvalDate(this.currentLocation[0]);
            await this.loadLocations({
              type: this.storedType,
              limit: this.getLimit()
            });
            this.$router.push(`/inventory`);
            this.$store.dispatch("app/setSnackbar", {
              text: "Evaluation Complete",
              color: "green"
            });
          } else this.serialDialog = true;
        } else if (this.serialOnly && this.storedType != 5) {
          await this.submitSerialOnly();
        } else if (this.storedType == 5) {
          await this.submitWeight();
        }
      } catch (error) {
        this.$store.dispatch("app/setSnackbar", {
          text: error.message,
          color: "red"
        });
      }
    },

    async submitSerialOnly() {
      let correctSerials = [];
      this.quantsModel.forEach(item => {
        item.enteredSerials.forEach(serial => {
          if (this.allSerials.includes(serial)) {
            correctSerials.push(true);
          } else {
            correctSerials.push(false);
          }
        });
      });

      if (
        !correctSerials.includes(false) &&
        correctSerials.length == this.allSerials.length
      ) {
        await this.updateEvalDate(this.currentLocation[0]);
        await this.loadLocations({
          type: this.storedType,
          limit: this.getLimit()
        });
        this.$router.push(`/inventory`);
        this.$store.dispatch("app/setSnackbar", {
          text: "Evaluation Complete",
          color: "green"
        });
      } else {
        this.$store.dispatch("app/setSnackbar", {
          text: "The serial(s) you entered do not match the system!",
          color: "red"
        });
      }
    },

    async submitWeight() {
      let isCorrect = true;
      this.quantsModel.forEach(async item => {
        let weight = parseFloat(item.weight);
        if (!weight || weight < 0.01) {
          window.alert("Weight must be greater than .01.");
          isCorrect = false;
          
        }
      });
      if (!isCorrect) return;

      this.quantsModel.forEach(async item => {
        await this.updateWeight({
          id: item.product_id[0],
          weight: item.weight
        });
      });

      await this.updateEvalDate(this.currentLocation[0]);
      await this.loadLocations({
        type: this.storedType,
        limit: this.getLimit()
      });
      this.$router.push(`/inventory`);
      this.$store.dispatch("app/setSnackbar", {
        text: "Evaluation Complete",
        color: "green"
      });
    },

    async handleNoInventory() {
      this.$router.push(`/inventory`);
      await this.updateEvalDate(this.currentLocation[0]);
      await this.loadLocations({
        type: this.storedType,
        limit: this.getLimit()
      });
    },

    async getTracking() {
      let pIDs = [];
      this.quantsModel.forEach(async product => {
        pIDs.push(product.product_tmpl_id[0]);
      });
      await this.searchProduct([
        {
          field: "id",
          operator: "in",
          value: pIDs
        }
      ]);
    },
    getLimit() {
      let limit = this.settings.filter(setting => {
        return (
          setting._id ===
          this.filters.filter(filter => {
            return filter.value === this.storedType;
          })[0].settingID
        );
      })[0].value;

      return limit;
    }
  }
};
</script>
<style></style>
